import React from "react";
import { Link, useLocation } from "react-router-dom";

const CategoryNavbar = () => {
  const location = useLocation(); // Get current path

  return (
    <div className="text-start mb-2 catnav">
      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/item-category" ? "activecat" : ""}`}
        to="/admin/item-category"
        data-discover="true"
      >
        What we do
      </Link>

      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/sub-category" ? "activecat" : ""}`}
        to="/admin/sub-category"
        data-discover="true"
      >
       Categories 
      </Link>


      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/make-brand" ? "activecat" : ""}`}
        to="/admin/make-brand"
        data-discover="true"
      >
        Type of Instruments
      </Link>


      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/instrument-type" ? "activecat" : ""}`}
        to="/admin/instrument-type"
        data-discover="true"
      >
        Make/Brand
      </Link>


      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/modal-number" ? "activecat" : ""}`}
        to="/admin/modal-number"
        data-discover="true"
      >
        Model Number
      </Link>


      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/six-category" ? "activecat" : ""}`}
        to="/admin/six-category"
        data-discover="true"
      >
        6th Level Category
      </Link>

      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/seven-category" ? "activecat" : ""}`}
        to="/admin/seven-category"
        data-discover="true"
      >
        7th Level Category
      </Link>


      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/eight-category" ? "activecat" : ""}`}
        to="/admin/eight-category"
        data-discover="true"
      >
        8th Level Category
      </Link>

      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/nine-category" ? "activecat" : ""}`}
        to="/admin/nine-category"
        data-discover="true"
      >
        9th Level Category
      </Link>

      {/* <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/ten-category" ? "activecat" : ""}`}
        to="/admin/ten-category"
        data-discover="true"
      >
        10th Level Category
      </Link> */}

      
      

      
      


    </div>
  );
};

export default CategoryNavbar;
